import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { IndicatorAction } from '../../../models/indicator.models';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ui-actions-switch-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ NzSwitchModule, FormsModule],
  template: `
    <div class="flex flex-row flex-wrap gap-x-2">
      <nz-switch #switch [ngModel]="switchValue()" (ngModelChange)="emitAction(switch)"></nz-switch>
    </div>
  `,
})
export class ActionsSwitchIndicatorComponent {
  switchValue = input<boolean>();
  onAction = output<IndicatorAction>();


  emitAction(
    action:any
  ) {
    if (!action.disabled) this.onAction.emit(action.id);
  }
}
